import LoadingBlock from '../../../components/loading-block/component-lib.esm.js';

//
var script = {
  components: {
    LoadingBlock
  }
};
export { script as default };